module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/plan1-3-fd7e29d9cfbab8fe45c824a10708cc12.webp";